import React, { useEffect, useState } from "react";
import { ReactComponent as LeftArrow } from "../../../../../assets/arrow-left.svg";
import { ReactComponent as LeftArrowDark } from "../../../../../assets/arrow-left-dark.svg";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useStateContext } from "../../../../../contexts/ThemeContext";
import { useDispatch, useSelector } from "react-redux";
import { gettingLinkList } from "../../../../../redux/slices/gettingLinksList/gettingLinkListSlice";
import { toast } from "react-hot-toast";
import ImageGridForm from "../forms/ImageGridForm";
import ConfirmModal from "../../../../../components/dashboard/modal/Confirm";
import {
  deleteBlock,
  resetDeletBlock,
} from "../../../../../redux/slices/block/deleteBlockSlice";
import useFetchBlock from "../../../../../hooks/useFetchBlock";
import {
  updateGettingImageGrid,
  updateGridReset,
} from "../../../../../redux/slices/cards/cardSlice";
import useLocales from "../../../../../hooks/useLocales";
import useSettings from "../../../../../hooks/useSettings";

import SpinnerGiff from "../../../../../assets/spinner.svg";

const EditImageGrid = () => {
  const { darkMode } = useSelector((state) => state.theme);
  const { translate } = useLocales();
  const { themeDirection } = useSettings();
  const user = JSON.parse(localStorage.getItem("user"));
  const userId = user.userid;
  const baseUrl = process.env.REACT_APP_API_URL;
  const { setActiveMainPageNav } = useStateContext();

  const [imageLoading, setImageLoading] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    setActiveMainPageNav(true);

    return () => {
      setActiveMainPageNav(false);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleSubmit = async (Images, preViewImageName) => {
    setImageLoading(true);
    const linkid = localStorage.getItem("linkId");
    const userID = JSON.parse(localStorage.getItem("user")).userid;

    const data = {
      coloum_name: "imageGrid",
      coloum_type: "imageGrid",
      picture: Images,
      link_id: linkid,
      user_id: userID,
      id: 1,
      optionId: optionId,
      imageFiles: preViewImageName,
      language: preData,
    };
    await dispatch(updateGettingImageGrid(data)).then(() => {
      fetchingLinksList(); // fetching link list after submiting , so list become refresh
    });

    setImageLoading(false);
  };

  //  fetching link list after submiting, so list become refresh
  function fetchingLinksList() {
    // data need for fetching link list
    const user = JSON.parse(localStorage.getItem("user"));
    const userId = user.userid;
    const usertoken = user.token;
    const linkId = localStorage.getItem("linkId");
    const linkListData = {
      userId,
      usertoken,
      linkId,
    };
    dispatch(gettingLinkList(linkListData));
  }

  // handling heading api reponses messages
  const {
    updateImageGrid,
    updateImageGridError,
    updateImageGridSuccess,
    updateImageGridLoading,
    updateImageGridErrorMsg,
  } = useSelector((state) => state?.cards?.updateImageGridCard);
  useEffect(() => {
    if (updateImageGrid?.status === "success" && updateImageGridSuccess) {
      toast.success(updateImageGrid?.message);
      fetchingLinksList();
      navigate("/dashboard/component");
    }
    if (updateImageGrid?.status === "failed" && updateImageGridSuccess) {
      toast.error(updateImageGrid?.message);
    }
    if (updateImageGridError) {
      toast.error(updateImageGridErrorMsg);
    }
    dispatch(updateGridReset());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [updateImageGridLoading, updateImageGrid]);

  const { optionId } = useParams();

  const userID = JSON.parse(localStorage.getItem("user")).userid;
  const url = baseUrl + "/api/user/getOption/" + userID + "/" + optionId;

  const { data, loading } = useFetchBlock(url);

  const preData = data?.data?.language;

  const deleteHandler = async () => {
    const obj = {
      optionId: optionId,
      userId: userId,
    };
    await dispatch(deleteBlock(obj)).then(() => {});
  };

  const {
    DeleteBlock,
    isDeleteBlockError,
    isDeleteBlockSuccess,
    isDeleteBlockLoading,
    isDeleteBlockErrorMsg,
  } = useSelector((state) => state?.deleteBlock);

  useEffect(() => {
    if (DeleteBlock?.data?.status === "success" && isDeleteBlockSuccess) {
      toast.success(DeleteBlock?.data?.message);
      navigate("/dashboard/component");
    }
    if (DeleteBlock?.data?.status === "failed" && isDeleteBlockSuccess) {
      toast.error(DeleteBlock?.data?.message);
    }
    if (isDeleteBlockError) {
      toast.error(isDeleteBlockErrorMsg);
    }
    dispatch(resetDeletBlock());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isDeleteBlockLoading, DeleteBlock]);

  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleDeleteModal = () => {
    deleteHandler();
    setIsModalOpen(false);
  };

  return (
    <>
      <ConfirmModal
        isOpen={isModalOpen}
        onCancel={() => setIsModalOpen(false)}
        onConfirm={handleDeleteModal}
        selectedLang={preData}
      />
      {loading && (
        <div
          style={{ zIndex: "999999" }}
          className="fixed inset-0 h-screen bg-[#ffffffa7] pt-5 flex justify-center items-center overflow-hidden"
        >
          <img src={SpinnerGiff} alt="..." />
        </div>
      )}
      <div className="px-6 md:px-0 mt-[37px] md:mt-0 flex items-center justify-between">
        <Link to={"/dashboard/component"}>
          <div className="flex text-body_copy2 items-center cursor-pointer gap-2">
            <div>
              {darkMode ? (
                <LeftArrowDark
                  className={`${
                    themeDirection === "rtl" ? "transform -scale-x-100" : ""
                  }`}
                />
              ) : (
                <LeftArrow
                  className={`${
                    themeDirection === "rtl" ? "transform -scale-x-100" : ""
                  }`}
                />
              )}
            </div>
            <p className="dark:text-color_v1_dark">
              {translate("image_grid")}
            </p>
          </div>
        </Link>
      </div>
      <ImageGridForm
        formType="edit"
        handleDelete={() => setIsModalOpen(true)}
        preHeaderData={data}
        submitHandlerParent={handleSubmit}
        isLoading={imageLoading}
      />
    </>
  );
};

export default EditImageGrid;
